import React, { useEffect, useState } from "react";
import Lottie from "react-lottie-player";

const WinLottie = () => {
  return (
    <>
      <Lottie
        speed={0.5}
        loop
        path={`./images/confetti.json`}
        play
        style={{
          width: "150%",
          position: "absolute",
          zIndex: 3,
          top: 0,
          left: "-25%",
          right: 0,
        }}
      />
    </>
  );
};

export default WinLottie;
